import { render, staticRenderFns } from "./newsletterG.vue?vue&type=template&id=67fc949b"
import script from "./newsletterG.vue?vue&type=script&lang=js"
export * from "./newsletterG.vue?vue&type=script&lang=js"
import style0 from "./newsletterG.vue?vue&type=style&index=0&id=67fc949b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports